import { adminSignin, info } from '@/api/SigninController'
import { getToken, setToken, removeToken } from '@/utils/auth'

const signin = {
  namespaced: true,
  state: {
    editData: {
      username: '',
      password: ''
    },
    token: getToken(),
    name: ''
  },
  mutations: {
    SET_EDIT: (state, data) => {
      state.editData[data.key] = data.val
    },
    SET_NAME: (state, data) => {
      state.name = data
    }
  },
  actions: {
    SignOut(context) {
      removeToken()
    },
    GetInfo(context) {
      return new Promise((resolve, reject) => {
        info(getToken()).then(res => {
          context.commit('SET_NAME', res.data.name)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    Signin(context) {
      return new Promise((resolve, reject) => {
        adminSignin(context.state.editData).then(res => {
          setToken(res.data.token)
          context.commit('SET_NAME', res.data.name)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default signin
